export default [
  // todo demo use
  {
    path: '/dev/tokenInput',
    name: 'tokenInput',
    component: () =>
      import(
        /* webpackChunkName: "tokenInput" */ '@/views/devPages/TokenInput.vue'
      )
  }
];
